var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vpassword"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.$tr(_vm.label)))]):_vm._e(),_vm._v(" "),_c('vpassinput',{attrs:{"error":_vm.error,"name":_vm.name,"open":_vm.open,"placeholder":_vm.placeholder},model:{value:(_vm.inner_val),callback:function ($$v) {_vm.inner_val=$$v},expression:"inner_val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }